import React, { ComponentProps } from 'react';

import { BlockType } from '../../types/api/ElementType';

import { asFetchableBlock } from '../../_lib/BlockFetcher';
import {
  PageTypeValidityPeriodEditView,
  PageTypeValidityPeriodEditViewProps,
} from './views/PageTypeValidityPeriodEditView';
import {
  PageTypeValidityPeriodDefaultView,
  PageTypeValidityPeriodDefaultViewProps,
} from './views/PageTypeValidityPeriodDefaultView';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';

type PageTypeValidityPeriodBlockProps = Views<
  DefaultView<PageTypeValidityPeriodDefaultViewProps> & EditView<PageTypeValidityPeriodEditViewProps>
>;

function PageTypeValidityPeriod({ views, activeView = 'default' }: PageTypeValidityPeriodBlockProps) {
  switch (activeView) {
    case 'edit':
      return <PageTypeValidityPeriodEditView {...views.edit.embedded} />;
    default:
      return <PageTypeValidityPeriodDefaultView {...views.default.embedded} />;
  }
}

export const PageTypeValidityPeriodBlock = asFetchableBlock(PageTypeValidityPeriod, BlockType.pagetypevalidityperiod);
export type PageTypeValidityPeriodBlock = ComponentProps<typeof PageTypeValidityPeriodBlock>;
